<template>
  <div :ref="containerRef" class="horizontal-scrollable__container">
    <div class="horizontal-scrollable__shadow --shadow-left"></div>
    <div class="horizontal-scrollable__shadow --shadow-right"></div>
    <div :ref="scrollableRef" class="horizontal-scrollable">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "HorizontalScrollable",
  props: {},
  data() {
    return {
      containerRef: "horizontalScrollableContainer_" + Math.random() * 10000,
      scrollableRef: "horizontalScrollable_" + Math.random() * 10000
    };
  },
  computed: {},
  mounted() {
    this.initScrollableDragEvents();
  },
  methods: {
    initScrollableDragEvents() {
      let mouseDown = false;
      let startX, scrollLeft;
      const horizontalScrollableContainer = this.$refs[this.scrollableRef];

      const startDragging = e => {
        mouseDown = true;
        startX = e.pageX - horizontalScrollableContainer.offsetLeft;
        scrollLeft = horizontalScrollableContainer.scrollLeft;
      };

      const stopDragging = () => {
        mouseDown = false;
      };

      const move = e => {
        e.preventDefault();
        if (!mouseDown) {
          return;
        }
        const x = e.pageX - horizontalScrollableContainer.offsetLeft;
        const scroll = x - startX;
        horizontalScrollableContainer.scrollLeft = scrollLeft - scroll;
      };

      new ResizeObserver(entries => {
        let totalScrollableContentWidth = 0;
        entries[0].target
          .querySelectorAll(":scope > div")
          .forEach(scrollableDiv => {
            totalScrollableContentWidth += scrollableDiv.offsetWidth;
          });

        let shadowRight = this.$refs[this.containerRef].querySelector(
          ":scope > .--shadow-right"
        );
        if (
          totalScrollableContentWidth <
          horizontalScrollableContainer.offsetWidth - 48
        ) {
          shadowRight.style.opacity = "0";
        } else {
          let scrollLeftOpacity =
            this.$refs[this.scrollableRef].scrollLeft /
            (this.$refs[this.scrollableRef].scrollWidth -
              this.$refs[this.scrollableRef].offsetWidth);
          shadowRight.style.opacity =
            1 - scrollLeftOpacity > 0.6 ? 0.6 : 1 - scrollLeftOpacity;
        }
      }).observe(this.$refs[this.scrollableRef]);

      horizontalScrollableContainer.addEventListener("mousemove", move, false);
      horizontalScrollableContainer.addEventListener(
        "mousedown",
        startDragging,
        false
      );
      horizontalScrollableContainer.addEventListener(
        "mouseup",
        stopDragging,
        false
      );
      horizontalScrollableContainer.addEventListener(
        "mouseleave",
        stopDragging,
        false
      );
      horizontalScrollableContainer.addEventListener(
        "scroll",
        () => {
          let shadowLeft = this.$refs[this.containerRef].querySelector(
              ":scope > .--shadow-left"
            ),
            shadowRight = this.$refs[this.containerRef].querySelector(
              ":scope > .--shadow-right"
            );

          let scrollLeftOpacity =
            this.$refs[this.scrollableRef].scrollLeft /
            (this.$refs[this.scrollableRef].scrollWidth -
              this.$refs[this.scrollableRef].offsetWidth);
          shadowLeft.style.opacity =
            scrollLeftOpacity > 0.6 ? 0.6 : scrollLeftOpacity;
          shadowRight.style.opacity =
            1 - scrollLeftOpacity > 0.6 ? 0.6 : 1 - scrollLeftOpacity;
        },
        false
      );
    },
    triggerManualScroll(direction) {
      const horizontalScrollableContainer = this.$refs[this.scrollableRef];

      if (direction === "left") {
        horizontalScrollableContainer.scrollBy({
          top: 0,
          left: -400,
          behavior: "smooth"
        });
      } else {
        horizontalScrollableContainer.scrollBy({
          top: 0,
          left: +400,
          behavior: "smooth"
        });
      }
    }
  }
};
</script>

<style scoped>
.horizontal-scrollable__container {
  position: relative;
  scroll-behavior: smooth;
}
.horizontal-scrollable__container > .horizontal-scrollable__shadow {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 10;
  height: 100%;
  width: 45px;
  border-radius: 8px;
}
.horizontal-scrollable__container
  > .horizontal-scrollable__shadow.--shadow-left {
  left: 0;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.9), transparent);
  opacity: 0;
}
.horizontal-scrollable__container
  > .horizontal-scrollable__shadow.--shadow-right {
  right: 0;
  background: linear-gradient(270deg, rgba(0, 0, 0, 0.9), transparent);
  opacity: 0.6;
}
.horizontal-scrollable {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  grid-auto-flow: column;
  grid-auto-columns: minmax(280px, 1fr);
  overflow-x: auto;
  overflow-y: auto;
  /* scroll-snap-type: x mandatory; */
  transform: translateZ(0);
  padding: 8px 16px 8px 0;
}
.horizontal-scrollable::-webkit-scrollbar-track {
  border-radius: 10px;
}

.horizontal-scrollable::-webkit-scrollbar {
  width: 5px;
  height: 17px;
  display: none !important;
}

.horizontal-scrollable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #242526;
  border: 5px solid rgba(0, 0, 0, 0); /* Transparent border together with `background-clip: padding-box` does the trick */
  background-clip: padding-box;
}
</style>
